import pdfMake from 'pdfmake/build/pdfmake.js';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';
import imgBg from './imgbg';
import Style from './pdfstyle';
import { INFO_TEXT, SLOGAN_TEXT } from './text';

interface PdfData {
  cert: string;
  name: string;
  lastname: string;
  birthday: string;
  from: string;
  to: string;
  nominal: string;
  municipality: string;
  link: string;
  logo: string;
}

const getBase64Image = (img: HTMLImageElement) => {
  // Create an empty canvas element
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;

  const ctx = canvas.getContext("2d");
  if (ctx) ctx.drawImage(img, 0, 0);

  return canvas.toDataURL();
}

const generatePdf = (data: PdfData) => {

  const docDefinition: { [key: string]: any } = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [40, 35, 40, 20],

    background: [
      {
        image: imgBg,
        width: 595,
      },
    ],

    content: [
      {
        text: `№ ${data.cert}`,
        style: [
          'darkGreen',
          'number',
        ],
      },
      {
        text: data.name,
        style: [
          'textAlignment',
          'darkGreen',
          'name',
        ],
      },
      {
        text: data.lastname,
        style: [
          'textAlignment',
          'darkGreen',
          'name',
        ],
      },
      {
        text: data.birthday,
        style: [
          'textAlignment',
          'acridGreen',
          'birth',
        ],
      },
      {
        text: `с ${data.from} по ${data.to}`,
        style: [
          'textAlignment',
          'darkGreen',
          'cert',
        ],
      },
      {
        text: `номинал ${data.nominal}`,
        style: [
          'textAlignment',
          'darkGreen',
          'cert',
        ],
      },
      {
        text: data.municipality,
        style: [
          'textAlignment',
          'acridGreen',
          'city',
        ],
      },
      {
        text: [
          INFO_TEXT,
          {
            text: data.link,
            link: data.link,
            decoration: 'underline',
            color: '#1d70b8',
          },
        ],
        style: [
          'textAlignment',
          'acridGreen',
          'info',
        ],
      },
      {
        text: SLOGAN_TEXT,
        style: [
          'textAlignment',
          'slogan',
        ],
      },
    ],

    styles: Style,
  };

  if (data.logo) {
    docDefinition.content.push({
      image: data.logo,
      fit: [70, 70],
      style: 'logo',
    });
  }

  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.createPdf(docDefinition).download(`${data.cert}.pdf`);

};

export { getBase64Image };

export default generatePdf;



// WEBPACK FOOTER //
// ./src/tools/generatepdf/index.ts